import FanLoadingIcon from 'components/FanLoadingIcon';
import RangeSlider from 'components/RangeSlider';
import Switch from 'components/Switch';
import { SENSOR_MAX_LAT, SENSOR_MAX_LNG, SENSOR_MIN_LAT, SENSOR_MIN_LNG } from 'constants/config';
import { DIALOG_ERROR_CONFIRM_TIME_LESS_THAN_SCAN_TIME, DIALOG_ERROR_INVALID_CONFIRM_TIME, DIALOG_ERROR_INVALID_LAT, DIALOG_ERROR_INVALID_LNG, DIALOG_ERROR_INVALID_SCAN_TIME, TEXT_BUTTON_UPDATE, TEXT_LATITUDE, TEXT_LONGITUDE, TEXT_MODIFY_BOUNDARY_SETTING, TEXT_ZOOM_RATE } from 'constants/message';
import { useDialog } from 'context/DialogContext';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useDebouncedCallback } from 'use-debounce';
import "./ModifyGeneralSettingForm.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { MENU_TYPE } from 'utils/constanst';


const propTypes = {
  initSetting: PropTypes.object,
  onSubmit: PropTypes.func
};
const defaultProps = {
  initSetting: {},
  onSubmit: (data) => { }
};
const ModifyGeneralSettingForm = (props) => {
  /*** States and Variables ***/
  const { initSetting } = props;
  const {
    register, handleSubmit, control, reset, watch
  } = useForm();
  const { error } = useDialog();
  const watchForcedLogout = watch('forcedLogoutOn', false);
  /*** Processing ***/
  React.useEffect(() => {
    reset({
      scanTime: initSetting.scanTime || 3,
      confirmTime: initSetting.confirmTime || 30,
      appTitle: initSetting.appTitle || '冠水監視',
      apiAuth: initSetting.apiAuth || '',
      alertOn: !!initSetting.alertOn,
      zoomOnClick: !!initSetting.zoomOnClick,
      statusHoldTimes: initSetting.statusHoldTimes || 1,
      zoom: initSetting.zoom || 10,
      menuType: initSetting.menuType || MENU_TYPE.DRAWER,
      cameraWindowButtonOn: !!initSetting.cameraWindowButtonOn,
      borderSettings: initSetting.borderSettings || [],
      videoOverlay: !!initSetting.videoOverlay,
      forcedLogoutOn: !!initSetting.forcedLogoutOn,
      forcedLogoutDays: initSetting.forcedLogoutDays || 30,
    });
  }, [initSetting])

  /*** Sub Components ***/

  /*** Event Handlers ***/
  const onSubmit = (data) => {
    const parsedScanTime = parseInt(data.scanTime);
    const parsedConfirmTime = parseInt(data.confirmTime);
    const parsedForcedLogoutDays = parseInt(data.forcedLogoutDays);
    if (!isFinite(parsedScanTime) || isNaN(parsedScanTime) || parsedScanTime < 1 || parsedScanTime > 60) {
      error(DIALOG_ERROR_INVALID_SCAN_TIME);
      return;
    }
    if (!isFinite(parsedConfirmTime) || isNaN(parsedConfirmTime) || parsedConfirmTime < 1 || parsedConfirmTime > 1440) {
      error(DIALOG_ERROR_INVALID_CONFIRM_TIME);
      return;
    }
    if (parsedConfirmTime < parsedScanTime) {
      error(DIALOG_ERROR_CONFIRM_TIME_LESS_THAN_SCAN_TIME);
      return;
    }
    if (data.forcedLogoutOn) {
      if (!isFinite(parsedForcedLogoutDays) || isNaN(parsedForcedLogoutDays) || parsedForcedLogoutDays < 1) {
        error("強制ログアウト日数は1日以上の整数で入力してください。");
        return;
      }
      data.forcedLogoutDays = parsedForcedLogoutDays;
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, '0');
      const formattedDate = `${now.getFullYear()}/${pad(now.getMonth() + 1)}/${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      data.forcedLogoutStartDate = formattedDate;

    } else {
      data.forcedLogoutStartDate = null;
    }
    data.scanTime = parsedScanTime;
    data.confirmTime = parsedConfirmTime;
    console.log('Submitted data:', data);
    props.onSubmit(data);
  }
  /*** Main Render ***/
  return <form
    onSubmit={handleSubmit(onSubmit)}
    className='modify_general_setting_form'>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        {`データ取得API実行間隔（分）`}
      </label>
      <div className='modify_general_setting_form_item_value'>
        <input
          type="number"
          min={1}
          max={60}
          step={1}
          style={{ textAlign: 'right' }}
          {...register('scanTime')} />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        {`異常検知時間 (分)`}
      </label>
      <div className='modify_general_setting_form_item_value'>
        <input
          type="number"
          min={1}
          max={1440}
          step={1}
          style={{ textAlign: 'right' }}
          {...register('confirmTime')} />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        アプリタイトル
      </label>
      <div className='modify_general_setting_form_item_value'>
        <input
          type="text"
          {...register('appTitle')} />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        APIキー
      </label>
      <div className='modify_general_setting_form_item_value'>
        <input
          type="password"
          {...register('apiAuth')} />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row_switch' >
      <label className='modify_general_setting_form_item_key_switch'>
        警報の保持・復旧
      </label>
      <div className='modify_general_setting_form_item_value_switch'>
        <Controller
          control={control}
          name='alertOn'
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        ステータス決定までのAPI実行回数
      </label>
      <div className='modify_general_setting_form_item_value'>
        <input
          type='number'
          step={1}
          style={{ textAlign: 'right' }}
          min={1}
          max={10}
          {...register('statusHoldTimes')} />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row_switch'>
      <label className='modify_general_setting_form_item_key_switch'>
        強制ログアウト
      </label>
      <div className='modify_general_setting_form_item_value_switch'>
        <Controller
          control={control}
          name='forcedLogoutOn'
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    </div>
    {watchForcedLogout && (
      <React.Fragment>
        {initSetting.forcedLogoutStartDate && (
          <div className='modify_general_setting_form_item_row' style={{ marginBottom: '8px', minHeight: 'unset' }}>
            <div className='modify_general_setting_form_item_key' style={{ visibility: 'hidden', height: 0, margin: 0 }}></div>
            <div className='modify_general_setting_form_item_value' style={{ fontSize: '13px', color: '#666', border: 'none', paddingLeft: '4px' }}>
              設定開始日時 : {initSetting.forcedLogoutStartDate}
            </div>
          </div>
        )}

        <div className='modify_general_setting_form_item_row'>
          <label className='modify_general_setting_form_item_key'>
            強制ログアウト日数 (日)
          </label>
          <div className='modify_general_setting_form_item_value'>
            <input
              type='number'
              step={1}
              min={1}
              style={{ textAlign: 'right' }}
              placeholder="30"
              {...register('forcedLogoutDays')} />
          </div>
        </div>
      </React.Fragment>
    )}
    <div className='modify_general_setting_form_item_row_switch'>
      <label className='modify_general_setting_form_item_key_switch'>
        オーバーレイ表示
      </label>
      <div className='modify_general_setting_form_item_value_switch'>
        <Controller
          control={control}
          name='videoOverlay'
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    </div>
    <div className='form-divider' />
    <div className='modify_general_setting_form_item_row'>
      マップ画面設定
    </div>
    <div className='modify_general_setting_form_item_row_switch'>
      <label className='modify_general_setting_form_item_key_switch'>
        アイコンクリック時のズーム
      </label>
      <div className='modify_general_setting_form_item_value_switch'>
        <Controller
          control={control}
          name='zoomOnClick'
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <label className='modify_general_setting_form_item_key'>
        メニュー表示
      </label>
      <div className='modify_general_setting_form_item_value'>
        <select
          {...register('menuType')}
        >
          <option value={MENU_TYPE.DRAWER}>ドロワー</option>
          <option value={MENU_TYPE.TAB}>タブ</option>
        </select>
      </div>
    </div>
    <div className='modify_general_setting_form_item_row_switch'>
      <label className='modify_general_setting_form_item_key_switch'>
        カメラウィンドウボタン表示
      </label>
      <div className='modify_general_setting_form_item_value_switch'>
        <Controller
          control={control}
          name='cameraWindowButtonOn'
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    </div>
    <div className='modify_general_setting_form_item_row'>
      <BorderSettings control={control} register={register} />
    </div>
    <div className='form-divider' />
    <div className='modify_general_setting_form_item_row'>
      <button
        className='button_active'>
        {TEXT_BUTTON_UPDATE}
      </button>
    </div>
  </form>;
}
ModifyGeneralSettingForm.propTypes = propTypes;
ModifyGeneralSettingForm.defaultProps = defaultProps;
export default ModifyGeneralSettingForm;


const BorderSettings = ({ control, register }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'borderSettings'
  });
  const { warningConfirm } = useDialog();

  const onAddOrRemove = () => {
    warningConfirm(
      <p>{TEXT_MODIFY_BOUNDARY_SETTING}</p>
    );
  };

  return (
    <div className="border_settings_container">
      <div className='modify_general_setting_form_item_border_settings_label'>
        <label>境界線設定</label>
        <button
          type="button"
          className='modify_general_setting_form_item_border_settings_add_button'
          // onClick={() => append({ id: Date.now(), location: '', zoom: 10, color: '#4287f5' })}
          onClick={onAddOrRemove}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className='modify_general_setting_form_item_border_settings_item'>
          <div className='modify_general_setting_form_item_border_settings_key'>
            <div>
              自治体名称
            </div>
            <div>&nbsp;&nbsp;{index + 1}&nbsp;&nbsp;</div>
          </div>
          <div className='modify_general_setting_form_item_border_settings_value'>
            <Controller
              control={control}
              name={`borderSettings.${index}.location`}
              render={({ field: { onChange, value } }) => (
                <SelectSearchProvinces
                  defaultValue={value.displayName}
                  onSelectPlace={(place) => {
                    onChange({
                      osmId: place.osm_id,
                      placeId: place.place_id,
                      displayName: place.display_name
                    });
                  }}
                />
              )}
            />
            <div className="modify_general_setting_form_item_border_settings_controls">
              <input
                type="color"
                {...register(`borderSettings.${index}.color`)}
                className='modify_general_setting_form_item_border_settings_color'
              />
              <div className='modify_general_setting_form_item_border_settings_delete_button'
                // onClick={() => remove(index)}
                onClick={onAddOrRemove}
              >
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const SelectSearchProvinces = ({ defaultValue, onSelectPlace }) => {
  const [listBoundingBox, setListBoundingBox] = React.useState([])
  const [text, setText] = React.useState(defaultValue);
  const [loading, setLoading] = React.useState(false);

  const searchBoundingBox = async (value) => {
    try {
      setLoading(true)
      const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${value}&polygon_geojson=1&countrycodes=jp&format=json`)
      const data = await res.json()
      setListBoundingBox(data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const onSelectBoundingBox = (box) => {
    setText(box.display_name)
    if (onSelectPlace) onSelectPlace(box);
    setListBoundingBox([])
  }
  const debounced = useDebouncedCallback(
    async (value) => {
      if (!value) {
        setListBoundingBox([])
        return
      }
      await searchBoundingBox(value.trim())
    },
    700
  );

  return <div className='select_search_provinces'>
    <input
      type='text'
      className='select_search_provinces_input'
      value={text}
      onChange={(e) => {
        setText(e.target.value)
        debounced(e.target.value)
      }}
    />
    {loading ? (<div className='select_search_provinces_loading'><FanLoadingIcon size={16} strokeWidth={2} /></div>) : (
      listBoundingBox.length > 0 ?
        <div className='select_search_provinces_list'>
          {listBoundingBox.map((item) => (
            <div
              key={item.place_id}
              className='select_search_provinces_item'
              onClick={() => onSelectBoundingBox(item)}
            >
              {item.display_name}
            </div>
          ))}
        </div> : ''
    )}
  </div>
}
